import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e4114fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "job_active_badge" }
const _hoisted_2 = {
  key: 0,
  class: "job_active_badge_label is-document-screening"
}
const _hoisted_3 = {
  key: 1,
  class: "job_active_badge_label is-interview"
}
const _hoisted_4 = {
  key: 2,
  class: "job_active_badge_label is-final-interview"
}
const _hoisted_5 = {
  key: 3,
  class: "job_active_badge_label is-unofficial-offer"
}
const _hoisted_6 = { class: "job_active_employment_status" }
const _hoisted_7 = { class: "job_active_company_name" }
const _hoisted_8 = { class: "job_active_number" }

import { PropType } from 'vue';
import { useRouter } from 'vue-router';
type Card = {
  orderId: number;
  shintyokuStatusBadgeName: string;
  empTypeName: string;
  ocupctgName: string;
  companyName: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ApplyOrderCard',
  props: {
  card: {
    type: Object as PropType<Card>,
    required: true,
  },
},
  setup(__props) {

const props = __props



const router = useRouter();

const status = (() => {
  const label = props.card.shintyokuStatusBadgeName;

  if (label.match(/書類選考/)) {
    return 1;
  }

  if (label.match(/.+次面接・選考/)) {
    return 2;
  }

  if (label.match(/最終面接・選考/)) {
    return 3;
  }

  if (label.match(/内定/)) {
    return 4;
  }
  return 0;
})();

const goDetail = () => {
  router.push({ name: 'g00', params: { orderId: props.card.orderId } });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "job_active",
    onClick: goDetail
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(status) === 1)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(props.card.shintyokuStatusBadgeName), 1))
        : _createCommentVNode("", true),
      (_unref(status) === 2)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(props.card.shintyokuStatusBadgeName), 1))
        : _createCommentVNode("", true),
      (_unref(status) === 3)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(props.card.shintyokuStatusBadgeName), 1))
        : _createCommentVNode("", true),
      (_unref(status) === 4)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(props.card.shintyokuStatusBadgeName), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, _toDisplayString(props.card.empTypeName) + " " + _toDisplayString(props.card.ocupctgName), 1),
    _createElementVNode("div", _hoisted_7, _toDisplayString(props.card.companyName), 1),
    _createElementVNode("div", _hoisted_8, "求人No." + _toDisplayString(props.card.orderId), 1)
  ]))
}
}

})